import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CTABanner from "../components/CTABanner";
import WhyChoose from "../components/WhyChoose";
import Testimonials from "../components/Testimonials";
import { Award, Globe2, Users, Heart } from "lucide-react";

const VALUES = [
  { icon: Award, title: "Excellence", desc: "Modern service with a 4.9/5 average rating from our early travellers." },
  { icon: Heart, title: "Care", desc: "Every itinerary is designed with the love and detail we'd want for our own family." },
  { icon: Users, title: "Community", desc: "98% of our travellers return — they're not customers, they're family." },
  { icon: Globe2, title: "Coverage", desc: "Direct partnerships in 250+ Indian and 40+ international destinations." },
];

const AboutPage = () => {
  return (
    <>
      <Header />
      <main>
        <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=1920&q=80"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 to-slate-900/50" />
          <div className="relative max-w-7xl mx-auto px-6 text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-xs font-semibold tracking-wider uppercase">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-400" /> Our Story
            </div>
            <h1 className="mt-4 text-4xl md:text-6xl font-bold tracking-tight max-w-3xl" style={{ fontFamily: "'Poppins', sans-serif" }}>
              An Indian love-story with travel
            </h1>
            <p className="mt-4 text-white/85 text-lg max-w-2xl">
              What started in 2025 as a family-run bus service in Taranagar, Churu is today a growing travel brand delighting hundreds of happy travellers every month.
            </p>
          </div>
        </section>

        <section className="py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
            <div className="space-y-5 text-slate-700 leading-relaxed text-lg">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-700 text-xs font-semibold tracking-wider uppercase">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-600" /> About PMR Travels
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Small enough to care. Big enough to deliver.
              </h2>
              <p>
                Founded by Mr. B.L. Baror in a single-office storefront, PMR Travels started with just one Tempo Traveller ferrying pilgrims across Rajasthan from Taranagar. Fresh in 2025 and already growing fast, we still answer every call ourselves.
              </p>
              <p>
                Today we run a modern fleet of luxury Volvo coaches, Mercedes tour buses and premium SUVs — alongside a full-service travel desk booking flights, hotels, and expert-curated tour packages across India.
              </p>
              <p>
                But some things haven't changed — our commitment to being on time, staying transparent about pricing, and treating every traveller like a guest in our own home.
              </p>
            </div>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=900&q=80"
                  alt="Our fleet"
                  className="w-full h-[520px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 max-w-xs border border-slate-100">
                <div className="text-3xl font-bold text-teal-700" style={{ fontFamily: "'Poppins', sans-serif" }}>2025</div>
                <div className="text-sm text-slate-600 mt-1">The year our journey began, in the by-lanes of Taranagar, Churu.</div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-slate-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center max-w-2xl mx-auto">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold tracking-wider uppercase">
                <span className="w-1.5 h-1.5 rounded-full bg-orange-500" /> Values
              </div>
              <h2 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
                What we stand for
              </h2>
            </div>
            <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {VALUES.map((v) => (
                <div key={v.title} className="bg-white p-6 rounded-2xl border border-slate-200 hover:border-teal-400 hover:shadow-lg transition">
                  <div className="w-12 h-12 rounded-xl bg-teal-600 text-white flex items-center justify-center">
                    <v.icon className="w-5 h-5" />
                  </div>
                  <h3 className="mt-4 font-bold text-slate-900 text-lg">{v.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <WhyChoose />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
